export default __webpack_public_path__ + "static/media/logo@2x.af7977d2.png";